import { AsyncScheduler } from '/druid/AsyncScheduler';

export class QueueScheduler extends AsyncScheduler {
}
